try {
  const parallaxImage = document.getElementsByClassName(
    "animated-intro__parallax-image"
  );
  const logo = document.querySelectorAll(".animated-intro__logo img");

  if (parallaxImage && logo) {
    new simpleParallax(parallaxImage, {
      scale: 1.2
    });

    new simpleParallax(logo, {
      orientation: "down",
      scale: 1.3,
      overflow: true
    });
  }
} catch (e) {
  console.log(e);
}
